export const customer = {
    namespaced: true,
    state: {
        customerOverviewSearch: null
    }, mutations: {
        storeCustomerOverviewSearch(state, search) {
            state.customerOverviewSearch = search;
        }
    }
}